<nb-card class="no-edge-card mb-0 estudio-cientifico-card">
	<div class="closeModal">
		<nb-icon class="m-1" icon="close-circle" [options]="{ animation: { type: 'zoom' } }" (click)="closeModal()"
			nbTooltip="Cerrar" nbTooltipPlacement="left">
		</nb-icon>
	</div>

	<nb-card-header class="border-bottom-0 estudio-header">
		<div class="d-flex align-items-center justify-content-between flex-wrap gap-3">
			<div class="d-flex align-items-center gap-3">
				<nb-icon icon="bar-chart-outline" class="header-icon"></nb-icon>
				<h4 class="m-0 header-title">Estudio Científico</h4>
			</div>
			<div class="stats-container">
				<div class="stat-item">
					<span class="stat-value">{{centers.length}}</span>
					<span class="stat-label">Total Centros</span>
				</div>
			</div>
			<button nbButton status="primary" size="small" class="dashboard-global-btn"
				nbTooltip="Ver dashboard global con datos agregados de todos los centros"
				(click)="verDashboardGlobal()">
				<nb-icon icon="bar-chart-2-outline"></nb-icon>
				<span>Dashboard global</span>
			</button>
			<div class="search-container">
				<nb-form-field>
					<nb-icon nbPrefix icon="search-outline"></nb-icon>
					<input nbInput type="text" placeholder="Buscar por nombre, dirección, país o email..."
						[(ngModel)]="searchTerm" (ngModelChange)="onSearch()" class="search-input">
				</nb-form-field>
			</div>
		</div>
	</nb-card-header>

	<nb-card-body class="p-0">
		<div class="table-container" *ngIf="!loading; else loadingTpl">
			<table class="estudio-table" *ngIf="filteredCenters.length > 0; else emptyTpl">
				<thead>
					<tr>
					<th (click)="sort('name')" class="sortable">
						Nombre <span class="sort-icon">{{getSortIcon('name')}}</span>
					</th>
					<th (click)="sort('centerName')" class="sortable">
						Código de Centro <span class="sort-icon">{{getSortIcon('centerName')}}</span>
					</th>
						<th (click)="sort('centerAddress')" class="sortable">
							Dirección <span class="sort-icon">{{getSortIcon('centerAddress')}}</span>
						</th>
						<th (click)="sort('centerCountry')" class="sortable">
							País <span class="sort-icon">{{getSortIcon('centerCountry')}}</span>
						</th>
						<th (click)="sort('centerMail')" class="sortable">
							Email <span class="sort-icon">{{getSortIcon('centerMail')}}</span>
						</th>
						<th (click)="sort('centerPhone')" class="sortable">
							Teléfono <span class="sort-icon">{{getSortIcon('centerPhone')}}</span>
						</th>
						<th class="th-actions">Acciones</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let center of pagedCenters">
						<ng-container *ngIf="editingCenterId !== center.idCenter">
							<td class="font-weight-bold">{{center.name || '—'}}</td>
							<td>{{center.centerName || '—'}}</td>
							<td>{{center.centerAddress || '—'}}</td>
							<td>{{center.centerCountry || '—'}}</td>
							<td>{{center.centerMail || '—'}}</td>
							<td>{{center.centerPhone || '—'}}</td>
							<td class="actions-cell">
								<button nbButton size="small" status="primary" ghost
									nbTooltip="Editar centro" (click)="startEdit(center)">
									<nb-icon icon="edit-outline"></nb-icon>
								</button>
								<button nbButton size="small" status="info" ghost
									nbTooltip="Ver detalle del centro" (click)="verDetalleCentro(center)">
									<nb-icon icon="eye-outline"></nb-icon>
								</button>
							</td>
						</ng-container>
						<ng-container *ngIf="editingCenterId === center.idCenter">
							<td><input nbInput fullWidth type="text" [(ngModel)]="editData.name" placeholder="Nombre" class="edit-input"></td>
							<td><input nbInput fullWidth type="text" [(ngModel)]="editData.centerName" placeholder="Código de Centro" class="edit-input"></td>
							<td><input nbInput fullWidth type="text" [(ngModel)]="editData.centerAddress" placeholder="Dirección" class="edit-input"></td>
							<td><input nbInput fullWidth type="text" [(ngModel)]="editData.centerCountry" placeholder="País" class="edit-input"></td>
							<td><input nbInput fullWidth type="text" [(ngModel)]="editData.centerMail" placeholder="Email" class="edit-input"></td>
							<td><input nbInput fullWidth type="text" [(ngModel)]="editData.centerPhone" placeholder="Teléfono" class="edit-input"></td>
							<td class="actions-cell">
								<button nbButton size="small" status="success" ghost
									nbTooltip="Guardar cambios" (click)="saveEdit(center)" [disabled]="savingCenter">
									<nb-icon icon="checkmark-outline"></nb-icon>
								</button>
								<button nbButton size="small" status="danger" ghost
									nbTooltip="Cancelar edición" (click)="cancelEdit()" [disabled]="savingCenter">
									<nb-icon icon="close-outline"></nb-icon>
								</button>
							</td>
						</ng-container>
					</tr>
				</tbody>
			</table>

			<div class="pagination-container" *ngIf="filteredCenters.length > 0">
				<span class="pagination-info">
					Mostrando {{(currentPage - 1) * pageSize + 1}} - {{currentPage * pageSize < filteredCenters.length ? currentPage * pageSize : filteredCenters.length}} de {{filteredCenters.length}}
				</span>
				<div class="pagination-buttons">
					<button nbButton size="small" ghost [disabled]="currentPage === 1" (click)="goToPage(1)">
						<nb-icon icon="arrowhead-left-outline"></nb-icon>
					</button>
					<button nbButton size="small" ghost [disabled]="currentPage === 1" (click)="goToPage(currentPage - 1)">
						<nb-icon icon="arrow-ios-back-outline"></nb-icon>
					</button>
					<span class="pagination-current">Página {{currentPage}} de {{totalPages}}</span>
					<button nbButton size="small" ghost [disabled]="currentPage === totalPages" (click)="goToPage(currentPage + 1)">
						<nb-icon icon="arrow-ios-forward-outline"></nb-icon>
					</button>
					<button nbButton size="small" ghost [disabled]="currentPage === totalPages" (click)="goToPage(totalPages)">
						<nb-icon icon="arrowhead-right-outline"></nb-icon>
					</button>
				</div>
			</div>

			<ng-template #emptyTpl>
				<div class="empty-state">
					<nb-icon icon="bar-chart-outline" class="empty-icon"></nb-icon>
					<p>No se encontraron centros</p>
				</div>
			</ng-template>
		</div>

		<ng-template #loadingTpl>
			<div class="loading-state">
				<nb-spinner status="primary" size="large"></nb-spinner>
			</div>
		</ng-template>
	</nb-card-body>
</nb-card>
